<h2 mat-dialog-title>Load Filterset</h2>
<button type="button" mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <siq-js-filtersets-grid [config]="filtersetGridConfig"></siq-js-filtersets-grid>
</mat-dialog-content>
<siq-js-filtersets-legend></siq-js-filtersets-legend>
